import type { AffineMatrix } from "../geometry/affine";
import { frameHandles, type Camera } from "../native/geometry";
import { corners } from "../native/transforms";

/** Original text-field border/controls, in screen pixels and only on the overlay. */
export function drawTextFrame(
  ctx: CanvasRenderingContext2D,
  matrix: AffineMatrix,
  camera: Camera,
  controls: boolean,
) {
  ctx.save();
  ctx.strokeStyle = "#86aef4";
  ctx.lineWidth = 1;
  ctx.setLineDash([5, 4]);
  ctx.beginPath();
  corners(matrix).forEach((p, i) => {
    const x = p.x * camera.zoom + camera.x,
      y = p.y * camera.zoom + camera.y;
    if (i) ctx.lineTo(x, y);
    else ctx.moveTo(x, y);
  });
  ctx.closePath();
  ctx.stroke();
  ctx.setLineDash([]);
  if (controls) {
    ctx.fillStyle = "#7ea7ef";
    for (const p of frameHandles(matrix))
      ctx.fillRect(
        p.x * camera.zoom + camera.x - 3.5,
        p.y * camera.zoom + camera.y - 3.5,
        7,
        7,
      );
  }
  ctx.restore();
}
